/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B100153 取引先別単価マスタ出力
 */
import { Box } from "@mui/material";
import {
  B000150TorihikiNmFrom,
  B000150TorihikiNmTo,
  B000200ShohinNmFrom,
  B000200ShohinNmTo,
  B100153ExcelRequest,
  B100153GetExcel,
  catchFileError,
} from "clients/rest";
import {
  msgState,
  SConfirmDialog,
  SFileButton,
  SFrame,
  SLabel,
  SNumberField,
  SText,
  STextField,
} from "components";
import { getClientMessage } from "messages";
import { labels } from "messages/labels";
import { B000150, B000200 } from "pages";
import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { download } from "services";
import { focusState, useFocus } from "states";

// 呼び出し時のプロパティ
type Props = Partial<{}>;

// コンポーネントで設定されるフィールドの型を定義する
type Fields = Partial<{
  torihikiCdFrom: string;
  torihikishitenCdFrom: string;
  torihikiNmFrom: string;
  torihikiCdTo: string;
  torihikishitenCdTo: string;
  torihikiNmTo: string;
  shohinCdFrom: string;
  shohinNmFrom: string;
  shohinCdTo: string;
  shohinNmTo: string;
}>;

// フィールドの初期値を設定する。
const defaultFields: Fields = {
  torihikiCdFrom: "",
  torihikishitenCdFrom: "",
  torihikiNmFrom: "",
  torihikiCdTo: "",
  torihikishitenCdTo: "",
  torihikiNmTo: "",
  shohinCdTo: "",
  shohinNmTo: "",
};

const focusId = "B100153";

export const B100153 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

const Page = (props: Props) => {
  // 状態管理の初期設定
  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });
  // フォーカス設定
  const { focus, register } = useRecoilValue(focusState(focusId));
  // 画面遷移
  const navigate = useNavigate();
  // エラー表示
  const setMsg = useSetRecoilState(msgState);

  // 初期表示イベント
  useEffect(() => {
    // 初回フォーカス先
    focus(1);
  }, []);

  // EXCELボタン押下時
  const handleClickExcelButton = () => {
    const fields = methods.getValues();

    const param: B100153ExcelRequest = {
      torihikiCdFrom: fields.torihikiCdFrom!,
      torihikishitenCdFrom: fields.torihikishitenCdFrom!,
      torihikiCdTo: fields.torihikiCdTo!,
      torihikishitenCdTo: fields.torihikishitenCdTo!,
      shohinCdFrom: fields.shohinCdFrom!,
      shohinCdTo: fields.shohinCdTo!,
    };

    B100153GetExcel(param)
      .then((response) => {
        download(response);
        setMsg(getClientMessage("B100153_001"));
      })
      .catch((reason) => {
        catchFileError(reason, navigate, setMsg);
      });
  };

  // レイアウト設定
  return (
    <FormProvider {...methods}>
      <SFrame
        title="取引先別単価マスタ出力"
        gridTemplateColumns="6rem 6rem 5rem 18rem 1rem 6rem 5rem 18rem"
      >
        <SText gridColumn="span 8">　</SText>

        <SLabel gridColumn="1">取引先</SLabel>
        <SNumberField
          name="torihikiCdFrom"
          label="取引先コードの範囲(開始)"
          code
          size={6}
          onBlur={() => B000150TorihikiNmFrom(methods, navigate, setMsg)}
          {...register(1)}
        />
        <SNumberField
          name="torihikishitenCdFrom"
          label="取引先支店コードの範囲(開始)"
          code
          size={4}
          dialog={<B000150 />}
          handleSubmit={(data: any) => {
            methods.setValue("torihikiCdFrom", data.tokuiCd);
            methods.setValue("torihikishitenCdFrom", data.tokuishitenCd);
            methods.setValue("torihikiNmFrom", data.tokuiNmr);
          }}
          onBlur={() => B000150TorihikiNmFrom(methods, navigate, setMsg)}
          {...register(2)}
        />
        <STextField
          name="torihikiNmFrom"
          label="取引先名の範囲(開始)"
          size={24}
          disabled
        />

        <SText>～</SText>

        <SNumberField
          name="torihikiCdTo"
          label="取引先コードの範囲(終了)"
          code
          size={6}
          onBlur={() => B000150TorihikiNmTo(methods, navigate, setMsg)}
          {...register(3)}
        />
        <SNumberField
          name="torihikishitenCdTo"
          label="取引先コードの範囲(終了)"
          code
          size={4}
          dialog={<B000150 />}
          handleSubmit={(data: any) => {
            methods.setValue("torihikiCdTo", data.tokuiCd);
            methods.setValue("torihikishitenCdTo", data.tokuishitenCd);
            methods.setValue("torihikiNmTo", data.tokuiNmr);
          }}
          onBlur={() => B000150TorihikiNmTo(methods, navigate, setMsg)}
          {...register(4)}
        />
        <STextField
          name="torihikiNmTo"
          label="取引先名の範囲(終了)"
          size={24}
          disabled
          gridColumn="span 1"
        />

        <SLabel gridColumn="1">商品コード</SLabel>
        <SNumberField
          label="商品コード"
          name="shohinCdFrom"
          size={10}
          {...register(5)}
          onBlur={() => B000200ShohinNmFrom(methods, navigate, setMsg)}
          dialog={<B000200 />}
          handleSubmit={(data: any) => {
            methods.setValue("shohinCdFrom", data.shohinCd);
            methods.setValue("shohinNmFrom", data.shohinNm);
          }}
          code
          gridColumn="span 2"
        />
        <STextField name="shohinNmFrom" size={24} disabled />
        <SText>～</SText>
        <SNumberField
          name="shohinCdTo"
          size={10}
          {...register(6)}
          onBlur={() => B000200ShohinNmTo(methods, navigate, setMsg)}
          dialog={<B000200 />}
          handleSubmit={(data: any) => {
            methods.setValue("shohinCdTo", data.shohinCd);
            methods.setValue("shohinNmTo", data.shohinNm);
          }}
          code
          gridColumn="span 2"
        />
        <STextField name="shohinNmTo" size={24} disabled />

        <Box gridColumn="span 7" />
        <SFileButton
          label={labels.buttons.excel}
          align="right"
          {...register(7)}
          dialog={
            <SConfirmDialog
              title="取引先別単価マスタ出力"
              msg={labels.dialog.masterExcelConfirmMessage}
            />
          }
          dialogAction="confirm"
          handleSubmit={handleClickExcelButton}
        />
      </SFrame>
    </FormProvider>
  );
};
